import React from "react";

export const renderStyledText = (text) => {
  if (typeof text !== "string") return "";

  let modifiedText = text.replace(/<b>(.*?)<\/b>/g, (match, p1) => {
    return `<span style="font-weight: bold;">${p1}</span>`;
  });
  modifiedText = modifiedText.replace(
    /<span style="color:\s*([^"]+)">([^<]+)<\/span>/g,
    (match, color, content) => {
      return `<span style="color: ${color};">${content}</span>`;
    }
  );
  return modifiedText;
};

export const renderContent = (content) => {
  return (content || []).map((item, index) => {
    if (item.type === "paragraph") {
      const plainText = item.data.text ? renderStyledText(item.data.text) : "";
      const alignment = item.tunes?.alignment?.alignment || "left";
      return (
        <p
          key={index}
          style={{ textAlign: alignment }}
          dangerouslySetInnerHTML={{ __html: plainText }}
        />
      );
    }

    if (item.type === "header") {
      const headingText = item.data.text ? renderStyledText(item.data.text) : "";
      const alignment = item.tunes?.alignment?.alignment || "left";
      const level = item.data.level || 3;

      return React.createElement(`h${level}`, {
        key: index,
        className: "bold",
        style: { textAlign: alignment },
        dangerouslySetInnerHTML: { __html: headingText },
      });
    }

    if (item.type === "table") {
      const rows = item.data.content ?? [];
      return (
        <table key={index} className="w-tbl-sla">
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={cellIndex > 0 ? "text-center" : ""}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: renderStyledText(cell),
                      }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (item.type === "list") {
      const { style = "unordered", items = [], content = [] } = item.data;
      const ListTag = style === "ordered" ? "ol" : "ul";

      const listItems =
        Array.isArray(items) && items.length > 0
          ? items.map((li) =>
              typeof li === "string"
                ? li
                : typeof li === "object" && "content" in li
                ? li.content
                : ""
            )
          : Array.isArray(content)
          ? content.map((c) => (Array.isArray(c) ? c.join(" ") : c))
          : [];

      return (
        <ListTag key={index} className="list">
          {listItems.map((text, itemIndex) => (
            <li
              key={itemIndex}
              dangerouslySetInnerHTML={{ __html: renderStyledText(text) }}
            />
          ))}
        </ListTag>
      );
    }

    return null;
  });
};
